import { render, staticRenderFns } from "./ArticleDetailed.vue?vue&type=template&id=c8767046&scoped=true"
import script from "./ArticleDetailed.vue?vue&type=script&lang=js"
export * from "./ArticleDetailed.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetailed.vue?vue&type=style&index=0&id=c8767046&prod&scoped=true&lang=css"
import style1 from "./ArticleDetailed.vue?vue&type=style&index=1&id=c8767046&prod&scoped=true&lang=css"
import style2 from "./ArticleDetailed.vue?vue&type=style&index=2&id=c8767046&prod&scoped=true&lang=css"
import style3 from "./ArticleDetailed.vue?vue&type=style&index=3&id=c8767046&prod&scoped=true&lang=css"
import style4 from "./ArticleDetailed.vue?vue&type=style&index=4&id=c8767046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8767046",
  null
  
)

export default component.exports